// extracted by mini-css-extract-plugin
export default {"globalDihkFont":"ConfirmationTemplate_globalDihkFont__2clUz","pageContent":"ConfirmationTemplate_pageContent__yVZoe","message":"ConfirmationTemplate_message__DERk-"};